<template>
  <model @clickHandler="modelClickHandler">
    <img
      src="@img/share-guide.png"
      class="share-guide btn"
      v-if="isShare"
      @click="isShare = false"
    />
    <div class="no-open item" key="no-open" v-else-if="process === 0">
      <div class="btn cj" @click="cj"></div>
    </div>
    <div class="no item" v-else-if="process < 0" key="no"></div>
    <div class="yes item" v-else key="yes">
      <p>抽中{{ prize }}元</p>
    </div>
    <div class="btn continue item" v-show="process !== 0 && !isShare" @click="exit"></div>
    <div class="btn share item" v-show="process !== 0 && !isShare" @click="isShare = true"></div>
  </model>
</template>

<script>
export default {
  name: 'redPacket',
  data() {
    return {
      process: 0,
      prize: 0,
      isShare: false,
    };
  },
  methods: {
    modelClickHandler() {
      if (this.isShare) this.isShare = false;
    },
    exit() {
      this.$parent.isCj = false;
    },
    async cj() {
      if (this.$loading.status) return;
      this.$loading.show('正在加载验证码');
      const vdata = await this.neCaptchaVerify().catch(() => {
        this.$loading.hide();
      });
      if (!vdata) return;
      this.$loading.show('正在抽奖');
      const result = await this.$axios
        .post(
          this.$store.api.lottery,
          this.$qs.stringify({
            vdata,
            callback_id: this.lotteryToken,
          }),
        )
        .catch((err) => console.log(err));
      this.$loading.hide();
      // console.log(result);
      if (result.data !== '') this.$parent.haveLottery = true;
      if (result.data.statusCode === '200') {
        this.process += 1;
        this.prize = result.data.data.prize_name
          .replace('红', '')
          .replace('元', '')
          .replace('包', '');
      } else {
        this.process -= 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  position: absolute;
  z-index: 11;
}
.no-open {
  @include w(477);
  @include center(477);
  @include h(463);
  @include bg("cj.png");
  top: 10vh;
  > .cj {
    position: absolute;
    @include w(190);
    @include center(190);
    @include h(87);
    bottom: 0;
  }
}

.no {
  @include w(606);
  @include center(606);
  @include h(684);
  @include bg("no.png");
  top: 2rem;
}
.yes {
  @include w(606);
  @include center(606);
  @include h(684);
  @include bg("yes.png");
  top: 2rem;
  > p {
    position: absolute;
    color: #333;
    top: 9rem;
    text-align: center;
    width: 100%;
    font-size: 1.2rem;
    line-height: 1.3em;
  }
}

.btn.item {
  @include w(216);
  @include h(83);
  top: 17rem;
}

.share {
  @include l(362);
  @include bg("btn-share.png");
}
.continue {
  @include l(120);
  @include bg("btn-continue.png");
}

.share-guide {
  @include w(434);
  right: 0.5rem;
  top: 0;
  position: absolute;
  z-index: 11;
}
</style>
